// Local field name constants (migrated from jl-design-system/form/fields)
const FIELD_NAMES = {
  TITLE: 'title',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  PHONE_NUMBER: 'phoneNumber',
  PHONE_NUMBER_ALTERNATIVE: 'phoneNumberAlternative',
};

export const extractClientDetails = (yourDetailsSection) => ({
  title: yourDetailsSection[FIELD_NAMES.TITLE],
  firstName: yourDetailsSection[FIELD_NAMES.FIRST_NAME],
  lastName: yourDetailsSection[FIELD_NAMES.LAST_NAME],
  phoneNumber: yourDetailsSection[FIELD_NAMES.PHONE_NUMBER],
  phoneNumberAlternative: yourDetailsSection[FIELD_NAMES.PHONE_NUMBER_ALTERNATIVE],
});
